const REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element");
const LEGACY_REACT_ELEMENT_TYPE = Symbol.for("react.element");
const REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
const isReactElementType = (value) => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const $$typeof = value.$$typeof;
  return $$typeof === REACT_ELEMENT_TYPE || $$typeof === LEGACY_REACT_ELEMENT_TYPE;
};
const isFragment = (value) => isReactElementType(value) && value.type === REACT_FRAGMENT_TYPE;
export {
  isFragment
};
